import makeStyles from '@mui/styles/makeStyles'
import {
  MyAccountTheme,
  MyAccountButtonSubmitClasses,
} from '@dxp-module/themes'

const buttonSubmitStyles = makeStyles<
  MyAccountTheme,
  object,
  MyAccountButtonSubmitClasses
>(
  ({ breakpoints }) => ({
    submitButtonContainer: {
      display: 'block',
      float: 'right',
      margin: '20px 10px',

      [breakpoints.down('sm')]: {
        float: 'unset',
        display: 'flex',
        justifyContent: 'center',
      },
    },
    btnContained: {},
    submitButton: {
      width: 250,
      '& > span': {
        textTransform: 'initial',
      },
    },
  }),
  { name: 'Signup_ButtonSubmit' }
)

export default buttonSubmitStyles
